import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import { uploadDriverDocuments } from '../../../service/AdminPanelService'

const CreateDriverForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createDriver, loadDriversByTopBase = async () => {}, notifySuccess = () => {}, notifyError = () => {} , topBases = [] , setTopBaseSearchByDriver = () => {}, topBaseSearchByDriver = {} }) => {
  const [selectedFiles, setSelectedFiles] = React.useState([])
  const fileInputRef = React.useRef(null)

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || [])
    setSelectedFiles(prev => [...prev, ...files])
  }

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index))
  }

  const handleCreate = async () => {
    try {
      const payload = { ...modalPayload }
      if (modalPayload.top_base_name) delete payload.top_base_name
      
      // Создаём водителя
      const result = await createDriver(payload)
      const driverId = result?.data?.id || result?.id
      
      // Загружаем документы, если есть
      if (selectedFiles.length > 0 && driverId) {
        try {
          await uploadDriverDocuments(driverId, selectedFiles)
        } catch (docErr) {
          console.error('Failed to upload documents:', docErr)
          notifyError(docErr, 'Водитель создан, но не удалось загрузить документы')
        }
      }
      
      if (payload.top_base) await loadDriversByTopBase(payload.top_base)
      closeModal()
      notifySuccess('Водитель создан')
    } catch (err) {
      console.error(err)
      notifyError(err, 'Не удалось создать водителя')
    }
  }

  return (
    <>
      <label>Сотрудник</label>
      <input
        placeholder="Поиск сотрудника..."
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">— Выберите сотрудника —</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{emp.label}</option>
        ))}
      </select>

      <label>ТОП-База</label>
      <input placeholder="ТОП-База" value={modalPayload.top_base_name || modalPayload.top_base || ''} readOnly />

      <label>Номер автомобиля</label>
      <input placeholder="Номер машины" value={modalPayload.vehicle_number || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_number: e.target.value }))} />

      <label>Модель автомобиля</label>
      <input placeholder="Модель машины" value={modalPayload.vehicle_model || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_model: e.target.value }))} />
      
      <label>Документы</label>
      <input 
        type="file" 
        ref={fileInputRef}
        multiple 
        onChange={handleFileChange}
        style={{ marginBottom: '8px' }}
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
      />
      {selectedFiles.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <strong>Выбрано файлов: {selectedFiles.length}</strong>
          <ul style={{ margin: '8px 0', padding: '0 0 0 20px' }}>
            {selectedFiles.map((file, index) => (
              <li key={index} style={{ marginBottom: '4px' }}>
                {file.name} ({(file.size / 1024).toFixed(1)} KB)
                <button 
                  onClick={() => removeFile(index)}
                  style={{ marginLeft: '8px', padding: '2px 6px', fontSize: '12px' }}
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={handleCreate} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreateDriverForm
